define('places/place-autocomplete',["require", "exports", "../util/log", "../views/autocomplete", "./places"], function (require, exports, log, autocomplete_1, places) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    /**
     * Initialize places autocomplete
     */
    function init(userId) {
        var input = document.getElementById("relocate-destination");
        if (input) {
            places.getPlaces(userId).then(function (all) {
                var nondropzones = all.filter(function (p) { return p.objectType !== "DZ" && p.alt !== null; });
                var ac = new autocomplete_1.Autocomplete({
                    input: input,
                    items: nondropzones,
                    minLength: 1,
                    display: function (place) { return places.formatPlace3(place); },
                    filter: function (place) { return places.formatPlace3(place); },
                    value: function (place) { return place.lat + ", " + place.lng + ", " + place.alt + " m"; }
                });
                ac.updates.subscribe(function (place) {
                    log.info("place select " + places.formatPlace3(place));
                });
            });
        }
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/places/place-autocomplete.js.map;
